import Modal from "../../Modal";
import styles from "./styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../features/LoaderSlice";
import { FormattedMessage, useIntl } from "react-intl";
import axiosInstance from "../../../api/axios";
import useNotification from "../../../hooks/useNotification";
const SubIdentitiesAliasesSwitcherModal = ({
  open,
  setOpen,
  switcherRowData,
  getSubIdentitiesAliases,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { successToast, errorToast } = useNotification();
  const controller_code = useSelector((state) => state.controllers.controller);
  const customer_scope = useSelector((state) => state.controller.scope);
  const userDetails = useSelector(
    (state) => state.userDetailsReducer.userDetail,
  );
  const { identity, type, value } = switcherRowData;

  const switchSubIdentitiesAliases = async () => {
    const switcherPayload = {
      digital_identity: {
        value: userDetails.value,
        type: userDetails.type,
        customer_scope,
        controller_code,
        ...(identity === "Sub Identity"
          ? {
              sub_identities: [
                {
                  type,
                  value,
                },
              ],
            }
          : {
              aliases: [
                {
                  type,
                  value,
                },
              ],
            }),
      },
    };

    dispatch(setLoader({ loading: true, label: "" }));
    try {
      const response = await axiosInstance.post(
        "/alternative-identity-switch",
        switcherPayload,
      );
      successToast(
        response?.data?.message[0] || "Identity switched successfully.",
      );
      if (getSubIdentitiesAliases) getSubIdentitiesAliases();
      setOpen(false);
    } catch (error) {
      errorToast(error?.data?.message || "Unable to switch identity.");
      setOpen(false);
    } finally {
      dispatch(setLoader({ loading: false, label: "" }));
    }
  };

  return (
    <Modal
      title={intl.formatMessage({
        id: "label.confirmation",
        defaultMessage: "Confirmation",
      })}
      open={open}
      setOpen={setOpen}
      okText={intl.formatMessage({
        id: "label.confirm",
        defaultMessage: "Confirm",
      })}
      canelText={intl.formatMessage({
        id: "label.cancel",
        defaultMessage: "Cancel",
      })}
      onSubmit={switchSubIdentitiesAliases}
    >
      <h2 className={styles["switcher-modal-heading"]}>
        <FormattedMessage
          id="switcher.sub-id-alias.title"
          defaultMessage="Are you sure you want to switch this Record to a {recordType}?"
          values={{
            recordType: identity === "Sub Identity" ? "Alias" : "Sub Identity",
          }}
        />
      </h2>
      <p className={styles["switcher-modal-message"]}>
        <FormattedMessage
          id="switcher.sub-id-alias.description"
          defaultMessage="By clicking on confirm you will permanently change this {recordType} into a {newRecordType}."
          values={{
            recordType: identity,
            newRecordType:
              identity === "Sub Identity" ? "Alias" : "Sub Identity",
          }}
        />
      </p>
    </Modal>
  );
};

export default SubIdentitiesAliasesSwitcherModal;
